export class Totals {
    CountImpressions = 0;
    CountUniquePlayers = 0;
    /**
     * Total duration in seconds this has been seened by users
     */
    DurationS = 0;
}
